/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { REVERT_TO_CETELEM_REQUEST, success, failure } from './action';

const events = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(REVERT_TO_CETELEM_REQUEST)
    .map(({ payload: { contractId } }) => contractId)
    .mergeMap((id) =>
      AjaxRequest.open(
        'get',
        `/admin/contractcustom/contracts/${id}/reverttocetelem`,
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(events);
